module.exports = __webpack_public_path__ + "media/images/frontend/plus-140bb24a31624cf15421da23b28c7ddd.svg";